/**
 * @file 虎牙主题的下拉刷新组件
 */
import { PullToRefresh as PullToRefreshAnt, PullToRefreshProps } from "antd-mobile";
import React from "react";
import GlobalTransition from "./GlobalTransition";

interface IPullToRefreshProps extends PullToRefreshProps {}
const PullToRefresh: React.FC<React.PropsWithChildren<IPullToRefreshProps>> = props => {
  const { children, ...rest } = props;
  return (
    <PullToRefreshAnt
      renderText={() => (
        /** 可传入theme参数-控制深浅色模式，建议搭配 `@huyafed/uikit` 一起使用 */ <GlobalTransition />
      )}
      {...rest}
    >
      {children}
    </PullToRefreshAnt>
  );
};

export default PullToRefresh;
